import { z } from 'zod';

const questionSchema = z.object({
    questionId: z.string().uuid(),
    questionTitle: z.string(),
    questionText: z.string().trim().min(1, { message: 'Question text is required' }),
    questionType: z.enum(['text', 'numeric', 'boolean']),
});

export const formSchema = z.object({
    questions: z.array(questionSchema),
});

export type FormValues = z.infer<typeof formSchema>;
